import { AnyAction, Reducer } from 'redux'
import { NavigationState, NavigationActions } from './types'
import {
  NAVIGATION_NAVIGATE,
  NAVIGATION_BACK,
  NAVIGATION_FORWARD
} from './actionTypes'

const navigation = (initialState: NavigationState): Reducer => (
  state: NavigationState = initialState,
  action: NavigationActions | AnyAction
): NavigationState => {

  switch(action.type) {

    case NAVIGATION_NAVIGATE:
      if(!action.route) return state
      let navigateState: NavigationState = {...state}
      navigateState.history.push(action.route)
      navigateState.index++
      return navigateState

    case NAVIGATION_BACK:
      if(state.index < 1) return state
      let backState: NavigationState = {...state}
      backState.index--
      return backState

    case NAVIGATION_FORWARD:
      if(state.index >= state.history.length) return state
      let forwardState: NavigationState = {...state}
      forwardState.index++
      return forwardState

    default:
      return state

  }

}

export default navigation
